import styles from './styles.module.scss'
import responsiveStyles from './responsiveStyles.module.scss'
import FloatingInfoBox from '../FloatingInfoBox'
import { itv } from '../../../assets/newsOutlets'

export const RenderTitleBannerContent = (groupsComplete: any, showInfoBox: any) => {
    return (
        <>
            <div className={`${styles.titleBanner} ${responsiveStyles.titleBanner}`}>
                <div className={styles.titleWrapper}>
                    <span className={`${styles.preText} ${responsiveStyles.preText}`}>
                        <b>YOU</b> could be owed compensation with an average value of
                    </span>
                    <span className={`${styles.highlightedAmount} ${responsiveStyles.highlightedAmount}`}>
                        £5,318<span style={{ fontSize: '0.5em', verticalAlign: 'super' }}>*</span>
                        <div className={styles.shineEffect} />
                    </span>
                    <span className={`${styles.postText} ${responsiveStyles.postText}`}>per client</span>
                    {/* Left Floating Info Box - 90 Seconds */}
                    <FloatingInfoBox
                        position="left"
                        showBox={showInfoBox}
                        message={
                            <>
                                Finish this form in less than <b style={{ fontSize: '1.5rem' }}>90 Seconds!</b>
                            </>
                        }
                        arrowsConfig={{
                            showBottomArrow: true,
                            showTopArrow1: true,
                            showTopArrow2: true,
                            bottomArrowType: 'arrow8',
                            topArrow1Type: 'arrow2',
                            topArrow2Type: 'arrow3',
                        }}
                    />
                </div>{' '}
            </div>
        </>
    )
}
